import { render, staticRenderFns } from "./rightInfo.vue?vue&type=template&id=05d29a34"
import script from "./rightInfo.vue?vue&type=script&lang=js"
export * from "./rightInfo.vue?vue&type=script&lang=js"
import style0 from "./rightInfo.vue?vue&type=style&index=0&id=05d29a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports